import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Testimonials2 from '../blocks/home/Testimonials2';
import services from '../data/services/servicesData.json';
import workCategories from '../data/portfolio/workCategories';
import BeforeAfterSlider from '../components/BeforeAfterSlider';
import ResponsiveImage from '../components/ResponsiveImage';

export default function Services() {
  return <>
    <main className="rg-page rg-expertise-page">
      <Helmet>
        <title>My Expertise | Photo Editing by Resham Gurung</title>
        <meta name="description" content="Explore 22 photo editing services, from natural portrait retouching to creative composites. Select a preview to see before-and-after examples." />
      </Helmet>
      <header className="rg-expertise-heading rg-container">
        <p className="rg-editorial-overline">THE ART OF PHOTO RETOUCHING</p>
        <h1>My expertise<em>.</em></h1>
        <p>Careful edits. Natural results. A little more possibility in every photograph.</p>
        <div className="rg-editorial-signature">Every detail, thoughtfully refined.</div>
      </header>
      <section className="rg-container rg-expertise-services" aria-label="Photo editing services">
        <div className="rg-expertise-intro">
          <div><h2>A closer look at the craft.</h2></div>
          <p>Drag the divider to compare. Click either side to view more.<br /><span>Sample previews; service-specific examples coming soon.</span></p>
        </div>
        <div className="rg-expertise-grid">
          {services.map(service => <article className="rg-expertise-card" key={service.link} aria-labelledby={`service-${service.link}`}>
            <div className="rg-expertise-comparison">
              {service.beforeAfter?.length ? <BeforeAfterSlider {...service.beforeAfter[0]} demo={false} linkTo={`/service/${service.link}`} alt={service.title} sizes="(max-width: 600px) calc(100vw - 72px), (max-width: 1100px) 45vw, 370px" /> :
                <Link to={`/service/${service.link}`} aria-label={`View before and after for ${service.title}`}>
                <ResponsiveImage className="rg-expertise-still"
                  {...workCategories.find(category => category.slug === (service.number === 20 ? 'wedding' : 'portraits')).images[0]}
                  sizes="(max-width: 600px) calc(100vw - 72px), (max-width: 1100px) 45vw, 370px"
                  alt={service.number === 20 ? 'Wedding couple in natural light' : 'Portrait selected from a photography collection'} loading="lazy" />
                </Link>}
            </div>
            <div className="rg-expertise-card-copy">
              <h2 id={`service-${service.link}`}><Link to={`/service/${service.link}`}>{service.title}</Link></h2>
              <p>{service.description}</p>
            </div>
          </article>)}
        </div>
      </section>
    </main>
    <div className="rg-testimonials-compact"><Testimonials2 /></div>
    <section className="rg-page rg-expertise-inquiry">
      <div className="rg-container">
        <p className="rg-editorial-overline">LET’S CREATE SOMETHING BEAUTIFUL</p>
        <h2>Your vision. A thoughtful finish.</h2>
        <p>Have a custom request or a gallery ready to edit? Let’s talk.</p>
        <div className="rg-editorial-end-actions">
          <Link to="/contacts?request=quote">Request a Quote</Link>
          <Link to="/contacts?request=sample">Request a Sample Edit</Link>
        </div>
      </div>
    </section>
  </>;
}
